export default __webpack_public_path__ + "static/media/Jayanandana.6ab9f71f.png";